export const checkEmailFormat = (email: string): boolean => {
	if (email) {
		const emailPattern = /^([a-zA-Z0-9.+_-])+@(([a-zA-Z0-9_-])+\.)+([a-zA-Z0-9]{2,4})$/;
		return emailPattern.test(email);
	}
	return false;
};

export const checkNameFormat = (key: string): boolean => {
	const alphaNumericRegularExpression = /^[a-zA-Z0-9&/.(),'-\s]*$/i;
	return alphaNumericRegularExpression.test(key);
};

export const passwordStrengthValidation = (password: string) => {
	const passwordValidStatus = {
		isPasswordLengthPassed: false,
		isLowercasePassed: false,
		isUppercasePassed: false,
		isNumerPassed: false,
		isAllCasesPassed: false
	};

	passwordValidStatus.isPasswordLengthPassed =
		password.length >= 8 && password.length <= 25 ? true : false;
	passwordValidStatus.isLowercasePassed = password.match(/(?=.*[a-z])/) ? true : false;
	passwordValidStatus.isUppercasePassed = password.match(/(?=.*[A-Z])/) ? true : false;
	passwordValidStatus.isNumerPassed = password.match(/(?=.*[0-9])/) ? true : false;

	passwordValidStatus.isAllCasesPassed =
		passwordValidStatus.isPasswordLengthPassed &&
		passwordValidStatus.isLowercasePassed &&
		passwordValidStatus.isUppercasePassed &&
		passwordValidStatus.isNumerPassed;

	return passwordValidStatus;
};

export const isNumeric = (value: string): boolean => {
	const REG_EXP = /^[0-9]+$/i;
	return REG_EXP.test(value);
};

export const isAlphaNumeric = (value: string): boolean => {
	const REG_EXP = /^[a-zA-Z0-9-_]+$/i;
	return REG_EXP.test(value);
};
